// FILE: src/components/modals/FavoritesModal.jsx

import React from 'react';
import { X, Heart, ShoppingCart, Plus } from 'lucide-react';

const FavoritesModal = ({ isOpen, onClose, favorites, setFavorites, addToCart }) => {
  if (!isOpen) return null;

  const removeFavorite = (productId) => {
    setFavorites(favorites.filter(item => item.id !== productId));
  };

  const handleAddToCart = (product) => {
    addToCart(product);
    // Optional: show toast notification
    alert(`${product.name} added to cart!`);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end z-50">
      <div className="bg-white w-full max-w-md mx-auto rounded-t-3xl p-6 max-h-[85vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800">My Favorites</h2>
          <button 
            onClick={onClose} 
            className="text-gray-500 hover:text-gray-700 p-2 hover:bg-gray-100 rounded-full transition-all"
          >
            <X size={24} />
          </button>
        </div>

        {favorites.length === 0 ? (
          <div className="text-center py-12">
            <Heart size={64} className="mx-auto text-gray-300 mb-4" />
            <p className="text-gray-500 text-lg">No favorites yet</p>
            <p className="text-gray-400 text-sm mt-2">Heart products you love to save them here</p>
          </div>
        ) : (
          <div className="space-y-4">
            {favorites.map((product) => (
              <div 
                key={product.id} 
                className="bg-white border-2 border-gray-200 rounded-xl p-4 hover:border-pink-300 transition-all"
              >
                <div className="flex gap-4">
                  <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4 flex items-center justify-center min-w-[80px]">
                    <span className="text-4xl">{product.image}</span>
                  </div>
                  
                  <div className="flex-1">
                    <div className="flex justify-between items-start mb-2">
                      <div>
                        <h3 className="font-semibold text-gray-800">{product.name}</h3>
                        <p className="text-xs text-gray-500">{product.description}</p>
                      </div>
                      <button
                        onClick={() => removeFavorite(product.id)}
                        className="text-red-500 hover:bg-red-50 p-2 rounded-full transition-all"
                      >
                        <Heart size={20} fill="currentColor" />
                      </button>
                    </div>
                    
                    <div className="flex items-center justify-between mt-3">
                      <div>
                        <span className="text-lg font-bold text-blue-600">₹{product.price}</span>
                        <span className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded ml-2">
                          {product.fat} fat
                        </span>
                      </div>
                      
                      <button
                        onClick={() => handleAddToCart(product)}
                        className="bg-blue-500 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-600 transition-all flex items-center gap-2"
                      >
                        <Plus size={16} />
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {favorites.length > 0 && (
          <div className="mt-6 bg-pink-50 border border-pink-200 rounded-xl p-4">
            <p className="text-sm text-gray-700">
              💡 <span className="font-semibold">Tip:</span> Add your favorite items to cart for quick reordering!
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FavoritesModal;